import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";
import { CONTACT } from "@/data/content";

export const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-background flex flex-col">
    <header className="bg-white border-b border-slate-200">
      <div className="container mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="legal-logo"><img src="/logo-color.png" alt="SML Municipal Consulting" className="h-9 w-auto" /></Link>
        <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-secondary transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to website
        </Link>
      </div>
    </header>

    <section className="bg-brand-dark grain relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-[0.08]" />
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-20 relative">
        <span className="overline text-secondary">Legal</span>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl font-medium tracking-tight text-white">{title}</h1>
        {updated && <p className="mt-4 text-sm text-white/50">Last updated: {updated}</p>}
      </div>
    </section>

    <main className="flex-1">
      <div className="container mx-auto px-4 md:px-8 py-14 md:py-20 max-w-3xl">
        <div className="prose-legal space-y-8">{children}</div>
        <div className="mt-14 rounded-xl border border-slate-200 bg-muted/40 p-6">
          <p className="text-sm text-slate-600">
            Questions about this policy? Contact us at{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-secondary font-medium">{CONTACT.email}</a> or{" "}
            <a href={`tel:${CONTACT.phoneRaw}`} className="text-secondary font-medium">{CONTACT.phone}</a>.
          </p>
        </div>
      </div>
    </main>

    <Footer />
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <div>
    <h2 className="font-heading text-xl md:text-2xl font-semibold text-primary">{heading}</h2>
    <div className="mt-3 text-[15px] text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);
